import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import CreatePumpDomesticSalesEnquiry from "./PumpDomesticSalesEnquiry/CreatePumpDomesticSalesEnquiry";
import CreatePumpInternationalSalesEnquiry from "./PumpInternationalSalesEnquiry/CreatePumpInternationalSalesEnquiry";
import CreateAraiMfgSalesEnquiry from "./AraiMfgSalesEnquiry/CreateAraiMfgSalesEnquiry";
import CreateAraiMfgDomesticSE from "./AraiMfgDomesticSalesEnquiry/CreateAraiMfgDomesticSE";

const CreateSalesEnquiry = () => {
  const [productType, setProductType] = useState();
  const [productCategory, setProductCategory] = useState();

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <CreatePumpDomesticSalesEnquiry />;
      } else if (productCategory === "International") {
        return <CreatePumpInternationalSalesEnquiry />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "International") {
        return <CreateAraiMfgSalesEnquiry />;
      } else if (productCategory === "Domestic") {
        return <CreateAraiMfgDomesticSE />;
      }
    } else {
      return null;
    }
  }

  return (

    <Card className="card">
      <Card.Header className="card-header">
        <h6>Add Sales Enquiry</h6>
        <Link to="/salesEnquiryIndex/1">
          <button className="button-70">BACK</button>
        </Link>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md="6">
            <Form.Group>
              <Form.Label>Select Enquiry Type:</Form.Label>
              <Form.Select
                onChange={(e) => {
                  setProductType(e.target.value);
                }}
                value={productType}
                disabled={productType ? true : false}
              >
                <option value="">--Please choose an option--</option>
                <option value="Pump Spare">Pump Spare</option>
                <option value="Manufacturing">Manufacturing</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md="6">
            <Form.Group>
              <Form.Label>Select a Enquiry Category:</Form.Label>
              <Form.Select disabled={!productType ? true : false || productCategory ? true : false} value={productCategory} onChange={(e) => setProductCategory(e.target.value)}>
                <option value="">--Please choose an option--</option>
                <option value="Domestic">Domestic</option>
                <option value="International">International</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {PageDisplay()}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CreateSalesEnquiry;
